import React from 'react';
import { useSelector } from 'react-redux';

import { selectCompanySettings, selectOrganizationLogo } from 'modules/settings/stores/company-settings-slice-handler';
import Preloader from './preloader';
import t from 'utils/translate';

export default function CompanyLogo() {
    const companySettings = useSelector(selectCompanySettings);
    const organizationLogo = useSelector(selectOrganizationLogo);

    return (
        <div className="company-logo">
            {companySettings.OrganizationLogoTimestamp > 0 && (
                <>
                    {organizationLogo.dataIsLoading ? (
                        <Preloader />
                    ) : (
                        <img alt={t('settings_company_logo')} src={organizationLogo.url} />
                    )}
                </>
            )}
        </div>
    );
}
